import csCZ from 'utils/localization/csCZ';

import navigation from './navigation';
import homepage from './homepage';
import contact from './contact';
import contact_form from './contact_form';
import help from './help';
import search from './search';
import dashlets from './dashlets';
import not_found from './not_found';
import viewer from './viewer';

const de: typeof csCZ = {
	navigation,
	homepage,
	contact,
	contact_form,
	help,
	search,
	dashlets,
	not_found,
	viewer,
};

export default de;
